import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
const Component = props => {
  return _jsx(_Fragment, {
    children: _jsxs("svg", Object.assign({
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props, {
      children: [_jsx("mask", {
        id: "tb18qrbx1__mask0_1_88500",
        style: {
          maskType: "alpha"
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "20",
        height: "20",
        children: _jsx("path", {
          d: "M10 19.5C4.7533 19.5 0.5 15.2467 0.5 10C0.5 4.7533 4.7533 0.5 10 0.5C15.2467 0.5 19.5 4.7533 19.5 10C19.5 15.2467 15.2467 19.5 10 19.5Z",
          fill: "#C4C4C4",
          stroke: "#152361"
        })
      }), _jsxs("g", {
        mask: "url(#tb18qrbx1__mask0_1_88500)",
        children: [_jsx("path", {
          d: "M31 0H1V20H31V0Z",
          fill: "#EE1C25"
        }), _jsx("path", {
          d: "M31 0H1V13.3333H31V0Z",
          fill: "#0B4EA2"
        }), _jsx("path", {
          d: "M31 0H1V6.66667H31V0Z",
          fill: "white"
        }), _jsx("path", {
          d: "M14.1165 4.69971H13.8465H9.99646H6.14979H5.87979L5.85313 4.96971C5.84646 5.02971 5.70312 6.43637 5.70312 9.52637C5.70312 10.9797 6.19312 12.2597 7.16312 13.333C7.83979 14.0864 8.72646 14.7197 9.86979 15.2697L9.99979 15.333L10.1298 15.2697C11.2731 14.7197 12.1598 14.0864 12.8365 13.333C13.8031 12.2597 14.2965 10.9764 14.2965 9.52637C14.2965 6.43637 14.1531 5.02971 14.1465 4.96971L14.1165 4.69971Z",
          fill: "white"
        }), _jsx("path", {
          d: "M9.99667 14.9995C8.35333 14.2062 6 12.6362 6 9.52285C6 6.40951 6.15 4.99951 6.15 4.99951H10H13.85C13.85 4.99951 14 6.41285 14 9.52285C13.9933 12.6362 11.6433 14.2062 9.99667 14.9995Z",
          fill: "#EE1C25"
        }), _jsx("path", {
          d: "M10.3496 8.70987C10.7962 8.71653 11.6629 8.7332 12.4362 8.47653C12.4362 8.47653 12.4162 8.7532 12.4162 9.07654C12.4162 9.39987 12.4362 9.67654 12.4362 9.67654C11.7262 9.43987 10.8496 9.4332 10.3496 9.43987V11.1565H9.64624V9.43987C9.14291 9.4332 8.26957 9.43987 7.55957 9.67654C7.55957 9.67654 7.57957 9.39987 7.57957 9.07654C7.57957 8.7532 7.55957 8.47653 7.55957 8.47653C8.33291 8.73654 9.20291 8.71653 9.64624 8.70987V7.62987C9.23957 7.62653 8.65624 7.64653 7.9929 7.86653C7.9929 7.86653 8.0129 7.58987 8.0129 7.26653C8.0129 6.9432 7.9929 6.66653 7.9929 6.66653C8.65291 6.88653 9.23624 6.90653 9.64291 6.9032C9.62291 6.21986 9.42291 5.35986 9.42291 5.35986C9.42291 5.35986 9.83291 5.3932 9.99624 5.3932C10.1596 5.3932 10.5696 5.35986 10.5696 5.35986C10.5696 5.35986 10.3696 6.21986 10.3496 6.9032C10.7562 6.90653 11.3396 6.88653 11.9996 6.66653C11.9996 6.66653 11.9796 6.9432 11.9796 7.26653C11.9796 7.58987 11.9996 7.86653 11.9996 7.86653C11.3396 7.64653 10.7529 7.62653 10.3462 7.62987V8.70987H10.3496Z",
          fill: "white"
        }), _jsx("path", {
          d: "M9.9967 10.9707C9.1667 10.9707 8.72337 12.1207 8.72337 12.1207C8.72337 12.1207 8.4767 11.5774 7.80004 11.5774C7.34337 11.5774 7.00671 11.984 6.79004 12.3607C7.62337 13.684 8.95004 14.5007 9.99337 15.004C11.0367 14.5007 12.3667 13.684 13.1967 12.3607C12.9834 11.984 12.6467 11.5774 12.1867 11.5774C11.51 11.5774 11.2634 12.1207 11.2634 12.1207C11.2634 12.1207 10.8267 10.9707 9.9967 10.9707Z",
          fill: "#0B4EA2"
        }), _jsx("path", {
          d: "M10 19.5C4.7533 19.5 0.5 15.2467 0.5 10C0.5 4.7533 4.7533 0.5 10 0.5C15.2467 0.5 19.5 4.7533 19.5 10C19.5 15.2467 15.2467 19.5 10 19.5Z",
          stroke: "#152361"
        })]
      })]
    }))
  });
};
export default Component;
